import {
  GET_PRACTICE_DETAIL,
  GET_PRACTICE_DETAIL_SUCCESS,
  GET_PRACTICE_DETAIL_FAILURE,
} from 'store/getPracticeDetail/getPracticeDetailAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getPracticeDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRACTICE_DETAIL:
      return { ...state, loading: true };
    case GET_PRACTICE_DETAIL_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_PRACTICE_DETAIL_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getPracticeDetailReducer;
